import { render, staticRenderFns } from "./Compra.vue?vue&type=template&id=53d7ec62"
import script from "./Compra.vue?vue&type=script&setup=true&lang=js"
export * from "./Compra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Compra.vue?vue&type=style&index=0&id=53d7ec62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports